export default {
	gridTemplateAreas: [
		'',
		`"i1 i1 i1 i2 i2 i2"
		"i1 i1 i1 i2 i2 i2"
		"i3 i3 i4 i4 i5 i5"
		"i3 i3 i4 i4 i5 i5"
		"i6 i6 i6 i8 i8 i8"
		"i7 i7 i7 i8 i8 i8"`
	],
	gridTemplateColumns: ['1fr', `repeat(6, 1fr)`],
	gridTemplateRows: ['1fr'],
	default: 'span 2',
	aspectRatios: {
		i6: 1 / 4,
		i7: 1 / 4
	}
};
